import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CustomMyTool } from '../../../models/dd-custom-tool.model';
import { DDElement } from '../../../models/dd-element.model';
import { RowLayout } from '../../../models/row-layout.model';

@Component({
    selector: 'app-tools-dialog',
    templateUrl: './tools-dialog.component.html',
    styleUrl: './tools-dialog.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule
    ]
})
export class ToolsDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: {tools: RowLayout, layoutTools: CustomMyTool []}, public dialogRef: MatDialogRef<ToolsDialogComponent>) { }

    addWidget(widget: DDElement) {
        this.dialogRef.close(widget.clone())
    }

}
